import { SwipeableDrawer } from "@mui/material";

const PriceCardDrawer = ({ Edit, setEdit, children, shippingId, width }) => {
  return (
    <>
      <SwipeableDrawer
        anchor={"right"}
        open={Edit.open}
        onClose={() =>
          setEdit({
            open: false,
            edit: "",
            title: "",
          })
        }
        PaperProps={{
          sx: {
            width: width || "500px",
            maxWidth: "700px",
          },
        }}
      >
        {children}
      </SwipeableDrawer>
    </>
  );
};

export default PriceCardDrawer;
